import { render, staticRenderFns } from "./Prontuario.vue?vue&type=template&id=f3347942&"
import script from "./Prontuario.vue?vue&type=script&lang=js&"
export * from "./Prontuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports